import { BugOutlined, ClusterOutlined } from "@ant-design/icons";
import { Alert, Badge, Button, Checkbox, Modal, Tabs } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";

import { mdmCardDemoStore as store } from "./mdmCardDemoStore";
import { MdmCardForm } from "./MdmCardForm/MdmCardForm";
import * as styles from "./MdmCardFormDemo.module.less";

/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-static-element-interactions: "off" */

export const MdmCardFormDemo: React.FC = observer(() => {
  const errors = Object.entries(store.formStore.errors);
  const [openErrors, setOpenErrors] = React.useState(false);
  const [openValues, setOpenValues] = React.useState(false);
  return (
    <div className={styles.box}>
      <div className={styles.tools}>
        <Button
          onClick={() => {
            store.loadMetaFromData("Meta 1").catch(onError);
          }}
        >
          Meta 1
        </Button>
        <Button
          onClick={() => {
            store.loadMetaFromData("Meta 1Sub").catch(onError);
          }}
        >
          Meta 1Sub
        </Button>
        <Button
          onClick={() => {
            store.loadMetaFromData("Meta Tabs").catch(onError);
          }}
        >
          Meta Tabs
        </Button>
        <Button
          onClick={() => {
            store.loadData("Data 1").catch(onError);
          }}
        >
          Data 1
        </Button>
        <Button
          onClick={() => {
            store.formStore.updateFields();
            setOpenValues(true);
          }}
          icon={<ClusterOutlined />}
        >
          View data
        </Button>
        <Checkbox
          checked={store.formStore.disabled}
          onChange={(e) => store.formStore.setDisabled(e.target.checked)}
          style={{ alignItems: "center" }}
        >
          Disabled
        </Checkbox>

        <Badge count={errors.length} size="small">
          <Button
            size="small"
            onClick={() => setOpenErrors(true)}
            icon={<BugOutlined />}
          />
        </Badge>

        <div className={styles.submitBox}>
          <Button type="primary" disabled={store.formStore.disabled}>
            Submit
          </Button>
        </div>
      </div>
      <div className={styles.content}>
        <MdmCardForm store={store.formStore} />
      </div>
      <Modal
        title="Ошибки"
        open={openErrors}
        onCancel={() => {
          setOpenErrors(false);
        }}
        footer={null}
      >
        {errors.length === 0 && <Alert type="warning" message="Нет ошибок" />}
        <div style={{ color: "red", cursor: "pointer" }}>
          {errors.map(([path, err]) => (
            <div
              key={path}
              onClick={() => {
                setOpenErrors(false);
                setTimeout(() => {
                  store.formStore.focusField(path).catch(onError);
                }, 20);
              }}
            >
              {path} =&gt; {err.message}
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        open={openValues}
        onCancel={() => setOpenValues(false)}
        footer={null}
        title="Данные"
      >
        <Tabs
          items={[
            {
              key: "1",
              label: "По полям",
              children: Object.entries(store.formStore.fields).map(
                ([path, field]) => (
                  <div key={path}>
                    {path}: {JSON.stringify(field.data)}
                  </div>
                ),
              ),
            },
            {
              key: "2",
              label: "Финальные",
              children: (
                <pre>
                  {JSON.stringify(
                    store.formStore.fields.contracts?.data,
                    null,
                    "  ",
                  )}
                </pre>
              ),
            },
          ]}
        />
      </Modal>
    </div>
  );
});

//         <pre>{openValues && JSON.stringify(store.formStore.values, null, "  ")}</pre>
